import React from "react";
import DetailModal from "./detail_modal";
import { ReactComponent as EditIcon } from "../../assets/svg/edit.svg";

export const EditDetailsLayout = (props) => {
  const handleModalOpen = () => {
    props.setDetailModalOpen(true);
  };
  return (
    <span className="ml-2">
      <button
        onClick={() => handleModalOpen()}
        className="font-bold rounded  hover:bg-gray-400 focus:shadow-outline focus:outline-none text-xs"
      >
        <EditIcon />
      </button>

      <DetailModal
        isOpen={props.detailModalOpen}
        onRequestClose={props.handleCloseModal}
        editData={props.detailsData}
        btid={props.btid}
        setEditing={props.setDetailsData}
        detailsData={props.activateObjects}
        setDetailModalOpen={props.setDetailModalOpen}
      />
    </span>
  );
};
